module.exports = __webpack_public_path__ + "img/ai-book.53ed8244.svg";